export default __webpack_public_path__ + "static/media/gallery_21.ae7de861.jpg";